import { ac } from '../../actions'

export const FETCH_SCHOOL_LISTING_CATEGORIES = 'FETCH_SCHOOL_LISTING_CATEGORIES'
export const FETCH_SCHOOL_LISTING_CATEGORIES_SUCCESS =
  'FETCH_SCHOOL_LISTING_CATEGORIES_SUCCESS'
export const FETCH_SCHOOL_LISTING_CATEGORIES_FAILED =
  'FETCH_SCHOOL_LISTING_CATEGORIES_FAILED'

export const fetchListingCategories = () => ac(FETCH_SCHOOL_LISTING_CATEGORIES)
